

import { UPDATE_GEN_ANSWER, UPDATE_GEN_RESPONSE, UPDATE_OS_CONTACTS } from './types'

export const updateGenAnswer = (payload) => {
    return {
        type: UPDATE_GEN_ANSWER,
        payload: payload
    }
}

export const updateGenResponse = (payload) => {
    return {
        type: UPDATE_GEN_RESPONSE,
        payload: payload
    }
}

export const updateOSContacts = (payload) => {
    return {
        type: UPDATE_OS_CONTACTS,
        payload: payload
    }
}